export const breadcrumbsTranslate = {
  '': 'Главная страница',
  reminders: 'Памятки и инструкции',
  profile: 'Профиль пользователя',
  'create-request': 'Создание обращения',
  appeal: '',
};